<div class="borderDivColor rounded-[10px] border bg-white p-5 filters-shadow">
  <div class="borderDivColor mb-5 flex justify-between border-b pb-3">
    <h3 class="labelColorText text-[16px] font-[600]" i18n="@@regionsSearchSettings">إعدادات البحث</h3>
  </div>

  <div class="flex flex-col gap-6 pt-2">
    <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
      <app-filter-input
        [label]="isArabic() ? 'المناطق' : 'Regions'"
        [placeholder]="isArabic() ? 'ابحث باسم المنطقة' : 'Search by region name'"
        type="text"
        [(value)]="quickSearch" />

      <app-filter-select-component
        [label]="isArabic() ? 'المحافظة' : 'Governorate'"
        [defaultOption]="isArabic() ? 'اختر المحافظة' : 'Select Governorate'"
        [options]="governorateOptions()"
        [value]="governorateId()"
        (valueChange)="onGovernorateChange($event)" />

      <app-filter-select-component
        [label]="isArabic() ? 'المدينة' : 'City'"
        [defaultOption]="
          !governorateId()
            ? isArabic()
              ? 'اختر محافظة أولاً'
              : 'Select governorate first'
            : loadingCities()
              ? isArabic()
                ? 'تحميل...'
                : 'Loading...'
              : isArabic()
                ? 'اختر المدينة'
                : 'Select City'
        "
        [options]="cityOptions()"
        [(value)]="cityId" />
    </div>

    <div class="grid grid-cols-1 gap-6 md:grid-cols-4">
      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ الإنشاء (من)' : 'Created On (From)'"
        [value]="createdOnFrom()"
        (valueChange)="createdOnFrom.set($event)"
        [isInvalid]="createdDateInvalid()" />

      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ الإنشاء (إلى)' : 'Created On (To)'"
        [value]="createdOnTo()"
        (valueChange)="createdOnTo.set($event)"
        [isInvalid]="createdDateInvalid()" />

      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ آخر تعديل (من)' : 'Last Modified (From)'"
        [value]="lastModifiedOnFrom()"
        (valueChange)="lastModifiedOnFrom.set($event)"
        [isInvalid]="lastModifiedDateInvalid()" />

      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ آخر تعديل (إلى)' : 'Last Modified (To)'"
        [value]="lastModifiedOnTo()"
        (valueChange)="lastModifiedOnTo.set($event)"
        [isInvalid]="lastModifiedDateInvalid()" />
    </div>

    @if (createdDateInvalid() || lastModifiedDateInvalid()) {
      <p class="text-[12px] text-red-500">
        {{ isArabic() ? "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية." : "From date cannot be after To date." }}
      </p>
    }

    <div class="borderDivcolor mt-2 flex items-end justify-between border-t pt-5">
      <app-filter-sorting-component
        [orderBy]="filters().orderBy || 'CREATION_DATE'"
        (orderByChange)="onOrderByChange($event)"
        [orderDir]="filters().orderDir || 'DESC'"
        [sortOptions]="sortOptions()"
        (toggleOrder)="onToggleSortOrder()" />

      <div class="flex gap-3">
        <button
          (click)="onResetFilters()"
          class="borderTabsColor textTabsColor rounded-[6px] border px-8 py-2 text-[13px] font-[500] hover:cursor-pointer hover:bg-red-50">
          <span i18n="@@regionsResetButton">مسح</span>
        </button>
        <button
          (click)="onApplyFilters()"
          class="bgTabsColor rounded-[6px] px-8 py-2 text-[13px] font-[500] text-white hover:cursor-pointer">
          <span i18n="@@regionsApplyButton">تطبيق</span>
        </button>
      </div>
    </div>
  </div>
</div>
